import React from 'react';

import styled from '@emotion/styled';

import { History__Subject } from '@admin/schema';
import { Card } from '@admin/styled/card';
import { Section } from '@admin/styled/section';
import { SectionTitle } from '@admin/styled/section_title';

import { Table as HistoriesTable } from '../histories/table';

const Subsection = styled.div`
  &:not(:first-of-type) {
    border-top: 1px solid #e4e8f0;
  }
`;

const SubsectionHeader = styled.div`
  padding: 14px 16px 0;
`;

const SubsectionTitle = styled.h3`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #1a1f36;
`;

const SubsectionBody = styled.div`
  padding: 12px 16px 16px;
`;

type FacilityHistorySectionProps = {
  facilityId: string;
  warehouseId?: string | null;
  depotId?: string | null;
  timezone?: string;
};

function HistorySubsection({
  title,
  id,
  type,
  timezone,
}: {
  title: string;
  id: string;
  type: History__Subject;
  timezone?: string;
}) {
  return (
    <Subsection>
      <SubsectionHeader>
        <SubsectionTitle>{title}</SubsectionTitle>
      </SubsectionHeader>
      <SubsectionBody>
        <HistoriesTable id={id} type={type} timezone={timezone} />
      </SubsectionBody>
    </Subsection>
  );
}

export const FacilityHistorySection: React.FC<FacilityHistorySectionProps> = ({
  facilityId,
  warehouseId,
  depotId,
  timezone,
}) => {
  return (
    <Section>
      <SectionTitle>History</SectionTitle>
      <Card>
        <HistorySubsection title="Facility" id={facilityId} type={History__Subject.Facility} timezone={timezone} />
        {warehouseId && (
          <HistorySubsection
            title="Consumer Storage"
            id={warehouseId}
            type={History__Subject.Warehouse}
            timezone={timezone}
          />
        )}
        {depotId && (
          <HistorySubsection title="Consumer Depot" id={depotId} type={History__Subject.Depot} timezone={timezone} />
        )}
      </Card>
    </Section>
  );
};
